// extracted by mini-css-extract-plugin
export default {"root":"NotificationPopover_root__iI0JV"};